import React, { useMemo } from "react";
import StackedTrendChart from "../../CHARTS/StackedTrendChart";
import { secondsToHHMM } from "../../Utilitie";

const STACK_KEYS = [
  "HQ_NORMAL_REST",
  "HQ_PR_22_HRS_REST",
  "HQ_PR_30_HRS_REST",
  "HQ_PR>30_HRS_REST",
  "HQ_CREW_REST_AT_OUT_STATION_REST_LOBBY",
  "HQ_CREW_REST_AT_OUT_STATION_REST_NON_LOBBY",
  "OUT_STN_CREW_AT_HQ_REST",
  "HQ_SISTER_LOBBY",
];

const COLORS = [
  "#0776c5", // blue
  "#028a4b", // green
  "#0fa8d6", // cyan
  "#5b5c9b", // purple
  "#1e548d", // steel blue
  "#60c053", // soft green
  "#00776d", // teal
  "#757e81", // grey
];

const CrewAvgTimeChart = ({ data = [], setSelectedLineBar, setResetData }) => {
  const processedData = useMemo(() => {
    const lobbyMap = {};
    data.forEach((item) => {
      const lobby = item.Lobby;

      if (!lobbyMap[lobby]) {
        lobbyMap[lobby] = { Lobby: lobby };

        STACK_KEYS.forEach((key) => {
          lobbyMap[lobby][key] = 0;
        });
      }

      STACK_KEYS.forEach((key) => {
        lobbyMap[lobby][key] += Number(item[key]) || 0;
      });
    });

    return Object.values(lobbyMap).map((item) => {
      const total = STACK_KEYS.reduce((sum, key) => sum + item[key], 0);

      return {
        ...item,
        TOTAL_TIME: total,
      };
    });
  }, [data]);

  return (
    <div className="newUiBody mt-3 col-md-12">
      <h5 className="text-center mb-3">
        Lobby-wise Crew Rest Time Distribution{" "}
      </h5>
      <StackedTrendChart
        data={processedData}
        setResetData={setResetData}
        setSelectedLineBar={setSelectedLineBar}
        xKey="Lobby"
        stackKeys={STACK_KEYS}
        colors={COLORS}
        title="Crew Average Rest Time - Lobby Wise"
        isTimeChart={true}
      />
    </div>
  );
};

export default CrewAvgTimeChart;
